import { useMutation } from "react-query";
import axios, { AxiosError } from "axios";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { spdrUrls } from "../../../URL/ApplicationUrls";
import { MdmApiError } from "../../../Errors/MdmApiError";
import { apiErrorNotificationToast } from "../../../Errors/apiErrorNotificationToast";

export const useExcludeSpdrsFromScope = () => {
  const navigate = useNavigate();
  return useMutation({
    mutationFn: (spdrIds: number[]) => {
      return axios.post(spdrUrls.excludeFromScope, spdrIds);
    },
    onSuccess: async () => {
      toast.success("SPDRs successfully excluded from scope");

      // FIXME - this should probably just refresh the grid
      setTimeout(() => {
        navigate(0);
      }, 2000);
    },
    onError: (error: AxiosError<MdmApiError>) => {
      apiErrorNotificationToast(error);
    },
  });
};
